export default {
  state: {
    alert: null
    // "visible":true,
    // "msg":"Producto Actualizado 🥳",
    // "type":"success"
  },
  mutations: {
    SET_ALERT_DATA (state, payload) {
      state.alert = payload
    }
  },
  actions: {
    setAlertData ({ commit }, payload) {
      commit('SET_ALERT_DATA', payload)
    }
  },
  getters: {
    alert (state) {
      return state.alert
    },
    alertHasContent (state) {
      return state.alert !== null
    }
  }
}
